export default "__VITE_ASSET__a27c5a6e__"